<template>
    <vx-modal
        v-model:visible="visible"
        data-test="terms-non-owner-modal"
        :preventClosing="props.hasTakenEffect"
        :stacked="switchingContext"
        padding="standard"
        size="md"
    >
        <template v-slot:header>{{ props.pendingTerm.title }}</template>

        <vx-alert shadow data-test="terms-non-owner-alert" class="mb-4" color="info" :closeable="false">
            <div>
                <template v-if="props.hasTakenEffect">
                    New Terms &amp; Conditions are now in effect. Your group Owner must accept these terms to restore
                    service.
                </template>

                <template v-else>
                    New Terms &amp; Conditions take effect on <strong>{{ props.formattedEffectiveAt }}</strong
                    >. Your group Owner must accept these terms to avoid interruptions in service.
                </template>
            </div>
        </vx-alert>

        <template v-slot:footer>
            <div class="flex flex-col gap-2">
                <vx-button
                    v-if="!props.hasTakenEffect"
                    data-test="terms-close-button"
                    color="muted"
                    size="lg"
                    @click="visible = false"
                >
                    Close
                    <font-awesome-icon :icon="faTimesCircle"></font-awesome-icon>
                </vx-button>

                <vx-button
                    v-if="props.hasTakenEffect"
                    data-test="terms-contact-support-link"
                    color="muted"
                    size="lg"
                    href="mailto:support@voxie.com"
                >
                    Contact Support <font-awesome-icon :icon="faEnvelope"></font-awesome-icon>
                </vx-button>

                <vx-button
                    data-test="terms-switch-context"
                    v-if="props.hasTakenEffect"
                    color="secondary"
                    size="lg"
                    @click="switchingContext = true"
                >
                    Switch Group
                    <font-awesome-icon :icon="faGrid2Plus"></font-awesome-icon>
                </vx-button>

                <vx-button
                    v-if="props.owner"
                    data-test="terms-contact-owner-link"
                    color="info"
                    size="lg"
                    :href="`mailto:${props.owner.email}`"
                >
                    Contact {{ props.owner.name }}
                </vx-button>
            </div>
        </template>
    </vx-modal>
    <vx-modal v-model:visible="switchingContext" size="md" :padding="false">
        <div class="w-full">
            <div class="absolute right-18 z-20 top-4">
                <vx-button color="muted" href="/logout"
                    >Logout

                    <font-awesome-icon :icon="faArrowRightFromBracket"></font-awesome-icon>
                </vx-button>
            </div>

            <navbar-context-switch :hideScroll="true"></navbar-context-switch>
        </div>
    </vx-modal>
</template>

<script lang="ts" setup>
import { faArrowRightFromBracket, faEnvelope, faGrid2Plus, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxAlert, VxButton, VxModal } from '@voxie/frontend-components';
import { ref } from 'vue';
import NavbarContextSwitch from '~/components/navbar/NavbarContextSwitch.vue';

import type { GroupOwnerContact, Term } from '~/services/termsClient.types';

const visible = defineModel('visible', { type: Boolean });

const props = defineProps<{
    pendingTerm: Term;
    hasTakenEffect: boolean;
    formattedEffectiveAt: string;
    owner?: GroupOwnerContact;
}>();

const switchingContext = ref(false);
</script>
